
import React, { Component } from 'react'
import MenuItem from 'material-ui/MenuItem'
import MasterDetailLayout from 'components/MasterDetailLayout'
import Header from 'components/Header'
import AddButton from 'components/AddButton'
import Hamburger from 'components/Hamburger'
import TasksTable from './Table'
import TaskForm from '../taskForm'
import FiltersPicker from 'components/FiltersPicker'
import Notifications from 'components/ListLayoutParts/Notifications'
import filtersActions from 'actions/filters'
import Search from 'components/Search'

export default class TaskPage extends Component {
	render() {
		let { props } = this
		let detailID = props.routeParams.id
		let header = (style) => (
			<Header {...{style}}>
				<Hamburger />
				<div>
					<FiltersPicker entity={'task'} />
					<Notifications />
					<div style={{
							float: "right"
						  , position: "relative"
						  , top: "-24px"
						  , left: "240px"}}
					>
						<Search  entity={'task'} id="search-tasks" style={{marginTop: "-8px"}}/><
					/div>
				</div>
			</Header>
		)
		return(
			<MasterDetailLayout
				header={header}
				master={props => <TasksTable {...props} detailID={detailID} />}
				detail={props => <TaskForm {...props} id={detailID} /> }
				detailColumns={1}
				detailOpen={!!detailID}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/manager/tasks/index.js